export const CUSTOM_SVG_ICONS = {
  'alarm-outlined': 'icons/alarm_outlined.svg',
  'alarm-filled': 'icons/alarm_filled.svg',
  'folder-outlined': 'icons/folder_outlined.svg',
  'folder-filled': 'icons/folder_filled.svg',
  'groups-outlined': 'icons/groups_outlined.svg',
  'groups-filled': 'icons/groups_filled.svg',
  'account-outlined': 'icons/account_outlined.svg',
  'account-filled': 'icons/account_filled.svg',
  'arrow-down': 'icons/arrow_down.svg',
  'arrow-up': 'icons/arrow_up.svg',
  'arrow-forward': 'icons/arrow_forward.svg',
  'arrow-back': 'icons/arrow_back.svg',
  'health-emergency': 'icons/health_emergency.svg',
  'thumb-up': 'icons/thumb-up.svg',
  'file-upload': 'icons/file-upload.svg',
  'file-upload-error': 'icons/file-upload-error.svg',
  'profile-frame': 'icons/profile_frame.svg',
  'upload-file': 'icons/upload_file.svg',
  'group-streamline': 'icons/group_streamline.svg',
  'navigation-menu': 'icons/navigation_menu.svg',
  company: 'icons/company.svg',
  'company-filled': 'icons/company.svg',
  'org-chart': 'icons/org-chart.svg',
  'org-chart-filled': 'icons/org-chart-filled.svg',
  'all-hands': 'icons/all-hands.svg',
  'all-hands-filled': 'icons/all-hands-filled.svg',
  policies: 'icons/policies.svg',
  'policies-filled': 'icons/policies-filled.svg',
  'descending-letter': 'icons/descending_letter.svg',
  'header-menu': 'icons/header_menu.svg',
  'onboarding-bank': 'icons/onboarding-bank.svg',
  like: 'icons/like.svg',
  cash: 'icons/cash.svg',
  file: 'icons/file.svg',
  lang: 'icons/lang.svg',
  logout: 'icons/logout.svg',
  person: 'icons/person.svg',
  edit: 'icons/edit.svg',
  toolbox: 'icons/toolbox.svg',
  bank: 'icons/bank.svg',
  pin: 'icons/loc-pin.svg',
  check: 'icons/check.svg',
  search: 'icons/search.svg',
  add: 'icons/add.svg',
  remove: 'icons/remove.svg',
  duplicate: 'icons/duplicate.svg',
  delete: 'icons/delete.svg',
  send: 'icons/send.svg',
  list: 'icons/list.svg',
} as const;

export type CustomSvgIconName = keyof typeof CUSTOM_SVG_ICONS;
